import React from 'react';
import { XIcon } from 'lucide-react';
import { Section } from './Shared';
import { BodySilhouette, TreeOfLife } from './BioDecor';
const points: {
  problem: string;
  result: string;
}[] = [{
  problem: 'Llego sin protocolo claro',
  result: 'Improviso preguntas sin sistema que me respalde'
}, {
  problem: 'No tengo una exploración inicial estructurada',
  result: 'Pierdo los primeros minutos críticos por dudas'
}, {
  problem: 'No tengo prácticas de cierre',
  result: 'La sesión termina sin una estructura clara de cierre'
}, {
  problem: 'Sin documentación y marco de actuación claros',
  result: 'Trabajás con menos respaldo documental y claridad sobre tus límites'
}, {
  problem: 'No sé cómo hacer seguimiento',
  result: 'Cada sesión es un empezar de cero, sin continuidad'
}, {
  problem: 'Termino emocionalmente agotado después de algunas sesiones',
  result: 'No tengo recursos de autocuidado ni de cierre para mí'
}, {
  problem: 'No puedo cobrar lo que valgo',
  result: 'Vendo sesiones, no sistemas. Siempre gano poco'
}, {
  problem: 'Pierdo pacientes',
  result: 'No explico bien el valor ni la estructura'
}];
export function PainPoints() {
  return <Section className="max-w-5xl" data-id="element-276" data-mp="27t8hx14hylog">
      <div className="relative overflow-hidden rounded-3xl border border-brand-blue/25 bg-brand-blueMist/60 p-6 md:p-10" data-id="element-277" data-mp="27s76uwnhdz6q">
        <BodySilhouette className="pointer-events-none absolute -right-4 -top-6 h-56 w-28 text-brand-blue/15" data-id="element-278" data-mp="23trdmb0t3ukv" />
        <div className="relative" data-id="element-279" data-mp="1b2puxzxwngwl">
          <h2 className="mb-8 text-center font-display text-2xl font-bold text-brand-blue md:text-4xl" data-id="element-280" data-mp="1b3reytwwfdqg">
            ❌ LO QUE PASA SIN EL KIT MAESTRO
          </h2>
          <ul className="grid gap-4 sm:grid-cols-2" data-id="element-281" data-mp="1k3eaiz2y5pbl">
            {points.map(point => <li key={point.problem} className="rounded-xl border-l-4 border-brand-blueMid bg-white p-5" data-id="element-282" data-mp="30hnvdj7zcvxo">
                <p className="mb-1.5 flex items-start gap-2 text-sm font-bold text-brand-blue" data-id="element-283" data-mp="2vitfap1edlh9">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand-goldDark" data-id="element-284" data-mp="1t55800xgijss" />
                  {point.problem}
                </p>
                <p className="pl-6 text-sm leading-relaxed text-brand-muted" data-id="element-285" data-mp="1y36ukvu3d190">→ {point.result}</p>
              </li>)}
          </ul>
        </div>
      </div>

      <div className="relative mt-12 overflow-hidden rounded-3xl border border-brand-gold/40 bg-brand-parchment p-8 text-center md:p-12" data-id="element-286" data-mp="274o4txkti8ps">
        <TreeOfLife className="pointer-events-none absolute -bottom-10 -left-6 h-48 w-28 text-brand-greenSoft/20" data-id="element-287" data-mp="1afymy796xg3t" />
        <div className="relative" data-id="element-288" data-mp="1egil9e5i2prj">
          <h3 className="font-display text-2xl font-bold leading-tight text-brand-blue md:text-4xl" data-id="element-289" data-mp="1jfbwt11886p2">
            ¿Y si esta fuera la última sesión que trabajás sin sistema?
          </h3>
          <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-brand-textLight md:text-lg" data-id="element-290" data-mp="1o7wtqbffizwt">
            Imaginá que la próxima sesión comienza con claridad total. Ordenás la exploración en 10 minutos. Aplicás
            el protocolo exacto. Proponés una práctica de integración. La sesión cierra con estructura. Sin dudas. Sin
            improvisación. Con mayor claridad en tu práctica.
          </p>
        </div>
      </div>
    </Section>;
}